/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-unresolved */
import {
    Breadcrumb, Button, Checkbox, Input, Table,
} from 'appkit-react';
import { Col, Row, Alert } from 'react-bootstrap';

import Loader from 'views/Shared/components/Loader';
import TenantWarningModal from './TenantWarningModal';
import '../styles/tenant.scss';

const Tenants = ({
    history, breadcrumbItems, columns, tableData, showWarningModal,
    setShowWarningModal, setConfirmDelete, tenantLoading, deleteTenantLoading,
    isChangeTenantStatusLoading, active, setActive, inactive, setInactive, filterString,
    setFilterString, errorMsg, showErrorAlert, setShowErrorAlert, successMsg,
    showSuccessAlert, setShowSuccessAlert,
}) => {
    if (showWarningModal) {
        return (
            <TenantWarningModal
                setConfirmDelete={setConfirmDelete}
                setShowWarningModal={setShowWarningModal}
                showWarningModal={showWarningModal}
            />
        );
    }
    if (tenantLoading || isChangeTenantStatusLoading || deleteTenantLoading) {
        return (
            <Loader />
        );
    }
    return (
        <div>
            <div className="true-comply-tenant_management_layout">
                <div className="true-comply-tenant_management_column-2">
                    <Breadcrumb items={breadcrumbItems} />
                    {showSuccessAlert && (
                        <Alert variant="success" onClose={() => setShowSuccessAlert(false)} dismissible="true">{successMsg}</Alert>
                    )}
                    {showErrorAlert && (
                        <Alert variant="danger" onClose={() => setShowErrorAlert(false)} dismissible="true">{errorMsg}</Alert>
                    )}
                    <Row>
                        <Col md={5}>
                            <div className="a-h2 title-label">
                                <span className="appkiticon icon-left-chevron-outline left-arrow-icon" onClick={() => history.push('/')} role="presentation" />
                                Tenant Management
                            </div>
                        </Col>
                        <Col style={{ textAlign: 'right' }}>
                            <Button
                                className="a-btn a-btn-primary a-btn-lg "
                                kind="primary"
                                size="lg"
                                style={{ marginLeft: '2rem' }}
                                onClick={() => history.push('/create-tenant')}
                            >
                                <span className="appkiticon icon-plus-fill" />
                                CREATE TENANT
                            </Button>
                        </Col>
                    </Row>

                    <Row className="true-comply-tenant_management_padding">
                        <Col md={2} style={{ paddingRight: 0 }} className="true-comply-tenant_management_filter_column">
                            <div className="true-comply-tenant_management-search_option">
                                <div>
                                    <div className="form-label">SEARCH</div>
                                    <div className="secondary-input-container a-apply-theme-background-gray-level-2">
                                        <Input
                                            inputBoxSize="sm"
                                            placeholder="Search here"
                                            value={filterString}
                                            onChange={e => setFilterString(e)}
                                        />
                                    </div>
                                </div>
                                <div className="form-label">STATUS</div>
                                <Row>
                                    <Col>
                                        <Checkbox
                                            checked={active}
                                            onChange={() => setActive(!active)}
                                        >
                                            <span className="checkbox-label">Active</span>
                                        </Checkbox>
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}>
                                    <Col>
                                        <Checkbox
                                            checked={inactive}
                                            onChange={() => setInactive(!inactive)}
                                        >
                                            <span className="checkbox-label">Inactive</span>
                                        </Checkbox>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col md={9} className="true-comply-tenant_management_padding true-comply-tenant_management-table_column">
                            <div style={{ marginTop: '0.5rem' }}>
                                <Table
                                    data={tableData}
                                    columns={columns}
                                    defaultPageSize={10}
                                    sortable
                                    size="lg"
                                    resizable
                                    className="-striped -highlight ReactTable rt-expander"
                                    noDataText="No Tenants Found!!!"
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
};

export default Tenants;
